import XTbl,{Xtc} from '../../components/x-table/index';
const tbl = new XTbl('/calendar/event/query/', 'calender');

tbl.add(new Xtc('title', 'Title'))
tbl.add(new Xtc('matter.title', 'Matter'))
tbl.add(new Xtc('start', 'Start').renderSlot('start'))
tbl.add(new Xtc('end', 'End').renderSlot('end'))


export default tbl;

